import { useState } from "react"
import { MainNavbar } from "./navbar"
import { MainSidebar } from "./sidebar"
import { SettingConstant } from "shared/constants/setting-constant"
import { logout } from "utils/external-login-helper"
import useIdleTimeout from "components/hooks/useIdleTimeout"
import { MainLayoutRoot, MainBox } from "./styles"
import { rootStore } from "stores/root-store"

const MainLayout = props => {
  const { children } = props
  const [isSidebarOpen, setSidebarOpen] = useState(true)

  const handleIdle = () => {
    rootStore.reset()

    logout()
  }

  const { idleTimer } = useIdleTimeout({ onIdle: handleIdle, idleTime: SettingConstant.TOKEN_EXPIRED_MINUTES * 60 })

  return (
    <>
      <MainLayoutRoot>
        <MainBox>{children}</MainBox>
      </MainLayoutRoot>
      <MainNavbar onSidebarOpen={() => setSidebarOpen(true)} />
      <MainSidebar onClose={() => setSidebarOpen(false)} open={isSidebarOpen} />
    </>
  )
}

export default MainLayout
